import { render } from "./Curriclum.vue?vue&type=template&id=225d3710&scoped=true"
import script from "./Curriclum.vue?vue&type=script&lang=js"
export * from "./Curriclum.vue?vue&type=script&lang=js"

import "./Curriclum.vue?vue&type=style&index=0&id=225d3710&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225d3710"]])

export default __exports__